import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {Trans, useTranslation} from "react-i18next"

import {Page} from "@indebted/components/Page"

function NotificationOfAssignment({ClientName}: {ClientName: string}) {
	const {t} = useTranslation()
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("customer_get.notification_of_assignment.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center" className="amp-mask">
					<Trans
						i18nKey="customer_get.notification_of_assignment.message"
						values={{ClientName: ClientName}}
					/>
				</Typography>
			</Grid>
		</Page>
	)
}

export {NotificationOfAssignment}
